<template>
  <div class="wait-style">
    <cube-scroll
      ref="scroll"
      :data="items"
      :options="options"
      @pulling-down="onPullingDown"
      @pulling-up="onPullingUp" class="page_scroll">
      <div class="noDataTip notice" v-if="info.length===0">
        <dl>
          <dt></dt>
          <dd>暂无数据</dd>
        </dl>
      </div>

      <!--          :disabled="disabledStores.includes(item.gather_name)"-->

      <el-checkbox-group v-model="checkedCities" @change="handle1">

        <div v-for="(item, index) in info" :key="index" class="dp-pai2" :class="'ceshi'+item.gather_name">


          <el-checkbox :label="item.order_id" v-show="item.classify == 1" :class="'custom'+item.order_id">
            {{ item.gather_name }}
          </el-checkbox>


          <router-link :to="{ name:'orderDetail', params: { order_id: item.order_id}}">
            <style-list :info='item' :type="type" @bindtype='bindtype'></style-list>
          </router-link>


        </div>

      </el-checkbox-group>

    </cube-scroll>
    <!-- v-show="" -->
    <div class="m-pop y-pop2 addressPop" v-show="expressShow">
      <div class="pop-bg"></div>
      <div class="inner2">
        <img class="close" @click="expressHide" src="../../assets/images/dele.png" alt="">
        <h5>录入快递单号</h5>
        <div class="con">
          <span>快递单号</span>
          <div class="r-con">
            <!-- style="background-image: url('../assets/images/y6i2.png)" -->
            <em class="r-con-icon js-sao" @click="getQRcode"></em>
            <input type="text" name="" v-model="sample_number">
          </div>
        </div>
        <div class="btn-area">
          <a @click.prevent="expressHide">再等等</a>
          <a @click="Cancel">确认提交</a>
        </div>
      </div>
    </div>
    <!-- <footer-bar :sy = '2'></footer-bar> -->
    <div class="com-foot1">
      <div class="dn-fr">
        <el-button type="primary" round @click="fillin">填写快递单号</el-button>
      </div>
    </div>

  </div>
</template>
<script>
// import footerBar from '../components/footer'
import styleList from '../views/styleList'

import $ from 'jquery'

export default {
  name: 'waitStyle',
  data() {
    return {
      expressShow: false,
      classify: '',
      user_id: localStorage.getItem('user_id'),
      items: [],
      info: [],
      options: {
        pullUpLoad: {
          threshold: 60,
          txt: {
            more: '加载更多',
            // noMore: '没有更多了'
          }
        },
        pullDownRefresh: {
          threshold: 60,
          // stop:,
          // stopTime:,
          txt: '刷新成功'
        },
      },
      pageNum: 1,
      allpage: null,
      type: 'wait',
      sample_number: '',
      order_id: '',
      type2: localStorage.getItem('type'),
      arr: [],
      // 全选
      // checkAll: false,
      // cityOptions: [],
      checkedCities: [],
      // isIndeterminate: false,
      panding: false,
      disabledStores: [],

      values: [],  // 存储value的数组
      labels: []   // 存储label的数组
    }
  },
  created() {
    this.loadPage(1, 1)


  },
  methods: {
    /*
             toXq(item) {
                this.$router.push({
                   name: 'orderDetail',
                   params: {
                      order_id: item
                   }
                })

             },
     */

    handle1(value1) {

      this.classify = 1

      console.log('value1:', value1)

      if (value1[0] != undefined) {
        let dingyi = $('.custom' + value1[0]).find('.el-checkbox__label').text()
        // console.log('.ceshi' + dingyi.trim().replace(/\s/g,""))

        // $('.dp-pai2').find('.el-checkbox__original').attr("disabled",true)
        $('.dp-pai2').css({ 'pointer-events': 'none' })

        // $('.ceshi' + dingyi.trim().replace(/\s/g,"")).find('.el-checkbox__original').attr("disabled",false);
        $('.ceshi' + dingyi.trim().replace(/\s/g, '')).css({ 'pointer-events': 'inherit' })

      } else {
        console.log('是undefined')
        // $('.dp-pai2').find('.el-checkbox__original').attr("disabled",false)
        $('.dp-pai2').css({ 'pointer-events': 'inherit' })
      }


    },


    handle2(value2, item) {
      // this.disabledStores=[]
      // this.disabledStores.push(item.gather_name)
      // console.log('disabledStores:',this.disabledStores)
// console.log(item.gather_name)

      // this.order_id = value.order_id
      // let checkedCount = value.length
      // this.checkAll = checkedCount === this.cityOptions.length
      // this.isIndeterminate = checkedCount > 0 && checkedCount < this.cityOptions.length
    },


    fillin() {
      console.log(this.checkedCities)
      if (this.checkedCities.length == 0) {
        this.$message({
          message: '选择不能为空',
          type: 'warning'
        })
      } else {
        this.expressShow = true

      }
    },
    loadPage(pageNum, type) {
      let _this = this

      _this.$http.api.expressage({
        page: pageNum,
        size: 10,
        user_id: _this.user_id
      }).then(result => {
        _this.allpage = Math.ceil(result.total / 10)
        // console.log(_this.allpage)
        let data = result.rows
        if (type == 1) {
          _this.info = [...data]
          _this.pageNum = 2
          _this.$refs.scroll.forceUpdate()
          console.log(_this.info)
        } else {
          if (data.length > 0 && _this.pageNum <= _this.allpage) {
            _this.info = _this.info.concat(data)
            _this.pageNum = _this.pageNum + 1
            _this.$refs.scroll.forceUpdate()
            console.log(_this.info)
          }
        }
      })
      if (_this.pageNum > _this.allpage) {
        setTimeout(function () {
          _this.$refs.scroll.forceUpdate()
        }, 300)
      }
    },

    expressHide() {
      this.expressShow = false
      this.sample_number = ''
      this.checkedCities=[]
    },
    onPullingDown() {
      // this.isLoading = false
      this.loadPage(1, 1)
    },
    onPullingUp() {
      let _this = this
      // _this.isLoading = false
      setTimeout(function () {
        _this.loadPage(_this.pageNum, 2)
      }, 800)
    },
    Sure() {
      this.expressShow = false
      // 点击电话弹窗
      this.$createDialog({
        type: 'confirm',
        // icon: 'cubeic-alert',
        title: '95338',
        // content: '我是内容',
        confirmBtn: {
          text: '通话',
          active: true,
          disabled: false,
          href: 'tel:95338'
        },
        cancelBtn: {
          text: '取消',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          // this.$createToast({
          //   type: 'warn',
          //   time: 1000,
          //   txt: '点击确认按钮'
          // }).show()
        },
        onCancel: () => {
          // this.$router.push('/orderCenter/0')
          // this.$router.push('/waitStyle')
          if (this.type2 == 1) {
            this.$router.push({ name: 'message', params: { type: 1 } })
          } else if (this.type2 == 2) {
            this.$router.push({ name: 'message', params: { type: 2 } })
          }

          // this.$createToast({
          //   type: 'warn',
          //   time: 1000,
          //   txt: '点击取消按钮'
          // }).show()
        }
      }).show()
    },
    Cancel() {
      let that = this
      if (!that.sample_number) {
        that.$createToast({
          txt: '快递单号不能为空',
          type: 'txt'
        }).show()
        return
      }

      that.tonc()

      // that.arr.push(that.order_id)
      // localStorage.setItem('order_id', JSON.stringify(that.arr))


      that.$http.api.bindNumber({
        ordersIdList: that.checkedCities,
        express_number: that.sample_number,
        // sample_time: this.sample_time
      }).then(result => {
        that.sample_number = ''
        that.expressShow = false
        that.$createToast({
          txt: '绑定成功',
          type: 'txt',
          during: 600
        }).show()
        that.info.forEach((item, index) => {
          if (item.order_id == that.order_id) {
            that.info.splice(index, 1)
          }
        })
        that.loadPage(1, 1)
        setTimeout(function () {
          that.Sure()
        }, 700)
      })


    },
    bindtype(type) {
      if (type.types == 'wait') {
        this.expressShow = true

        this.classify = type.expre.classify

        this.order_id = type.expre.order_id

        this.checkedCities.push(this.order_id)

        // console.log('this.order_id:',this.order_id)

      }
    },

    tonc(type) {
      let that = this
      console.log('classify:', that.classify)
      console.log('checkedCities:', that.checkedCities)

      if (that.classify == 1 || that.classify == 2) {

        /*
                 that.$http.api.toNc({
                   order_id: that.order_id
                 }).then((res) => {
                 })
*/
        that.$http.api.ListToNc({
          ordersIdList: that.checkedCities,
        })

      } else if (that.classify == 3) {

        /*
        that.$axios.post('http://101.89.115.91:80/nc/ToCareNc', {
           order_id: that.order.order_id
        }).then((res) => {
           if (res.data.status == 200) {

           }
        });
*/


        that.$http.api.toCareNc({
          ordersIdList: that.checkedCities,
        })

      }

    },
    getQRcode() {
      let _this = this
      this.$share.WxInit()
      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          _this.sample_number = result.split(',')[1]
        }
      })
    }
  },
  components: {
    styleList
  }

}
</script>
<style lang="less">
.el-checkbox__inner {
  transform: scale(1.4);
}

.m-pop {
  z-index: 102;

}


</style>
<style lang="less" scoped>
.page_scroll {
  bottom: 0;
}

.noDataTip {
  width: 100%;
  text-align: center;

  dl {
    padding-top: 30px;

  }
}

.addressPop {
  display: block;
}

.address-input {
  width: 100%;
  margin-bottom: 10px;
  height: 30px;
  line-height: 30px;

  label {
    width: 30%;
    float: left;
    height: 30px;
    line-height: 30px;
    margin-right: 4%;
  }

  input {
    width: 66%;
    float: right;
    border: 1px solid #ccc;
    outline: none;
    background: #fff;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
  }
}

.isshow {
  height: auto;
}

.inner2 {
  padding: 11px 0 0px;
  width: 80%;
  margin: 0 auto;

  .close {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
  }

  h5 {
    font-size: 15px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
  }

  a {
    line-height: 40px;
    width: 45%;
    height: 38px;
    background: #fff;
    color: #0087FF;
    font-size: 14px;
    padding: 0 10px;
    border-radius: 0;
    margin-top: 1px;
  }

  a:nth-child(1) {
    border-right: 1px solid #e1e1e1;
  }
}

.inner2 .con {
  width: 85%;
  margin: 0 auto;
  overflow: hidden;
  height: 40px;
  padding: 0 15px 0 21px;
  border: 1px solid rgba(0, 0, 0, .1);
  border-radius: 1px;
  margin-bottom: 5px;
  box-sizing: border-box;
}

.inner2 span {
  float: left;
  font-size: 12px;
  color: #666;
  line-height: 38px
}

.inner2 .r-con {
  overflow: hidden;
  position: relative
}

.inner2 .r-con input {
  display: block;
  height: 38px;
  line-height: 38px;
  width: 100%;
  border: none;
  background-color: transparent;
  text-align: right;
  color: rgba(102, 102, 102, .5)
}

.inner2 .r-con input {
  padding-right: 20px
}

.inner2 em {
  position: absolute;
  width: 38px;
  height: 38px;
  background-position: right center;
  background-repeat: no-repeat;
  -webkit-background-size: auto 15px;
  background-size: auto 15px;
  right: 0;
  top: 0;
  cursor: pointer
}

.em-img {
  background-image: url(../../assets/images/y6i3.png)
}

.r-con-icon {
  background-image: url('../../assets/images/y6i2.png');
}

.inner2 .r-con input {
  text-align: left;
  padding-left: 10px;
  padding-right: 0;
  padding-right: 25px;
}

.inner2 .btn-area {
  padding-top: 0;
}

.dp-pai2 {
  display: flex;
  align-items: center;
  padding: 0 0.2rem;

  .el-checkbox {
    width: 0.6rem;
  }

  a {
    flex-grow: 1;
  }
}
</style>


